document.addEventListener("DOMContentLoaded", function () {
  const footer_inp = document.getElementById("footer_inp");
  const footer_but = document.getElementById("footer_but");
  const email_verified = document.getElementsByClassName("email_verified")[0];
  const numberVerify = /^\d{10}$/;

  footer_inp.addEventListener("change", submitContactForm);
  footer_but.addEventListener("click", submitContactForm);

  function submitContactForm(e) {
    e.preventDefault();

    if (numberVerify.test(footer_inp.value)) {
      // footer_but.type = "submit";

      const options = {
        method: 'POST',
        headers: {
          'content-type': 'application/json-patch+json',
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3MTFlYTM2Ni1iMzU0LTQ2NjYtOGRjYS0xYjg4OTg5OTc5NGMiLCJ1bmlxdWVfbmFtZSI6ImNhcmVAc3VwZXJlcmdvLmluIiwibmFtZWlkIjoiY2FyZUBzdXBlcmVyZ28uaW4iLCJlbWFpbCI6ImNhcmVAc3VwZXJlcmdvLmluIiwiYXV0aF90aW1lIjoiMTIvMzEvMjAyNCAwNzoxODo1MyIsInRlbmFudF9pZCI6IjM4NzEyMiIsImRiX25hbWUiOiJtdC1wcm9kLVRlbmFudHMiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJBRE1JTklTVFJBVE9SIiwiZXhwIjoyNTM0MDIzMDA4MDAsImlzcyI6IkNsYXJlX0FJIiwiYXVkIjoiQ2xhcmVfQUkifQ.lIzxjuSHBy7-vO3z70YIs4kzDE6dJTtttweKVNCQA9s'
        },
        body: JSON.stringify({
          "name": "",
          "customParams": [
            {
              "name": "promotion",
              "value": "TRUE"
            },
            {
              "name": "placement",
              "value": "footer"
            }
          ]
        })
      };
      
      if(localStorage.getItem("newsletter") !== "collected"){
        fetch(`https://live-mt-server.wati.io/387122/api/v1/addContact/${"91"+footer_inp.value}`, options)
        .then(res => res.json())
        .then(res => console.log(res))
        .catch(err => console.error(err));
      }
      
      footer_inp.style.borderColor = "#969696";
      footer_but.style.borderColor = "#969696";
      email_verified.innerHTML = "Successfully subscribed ✅";
      setTimeout(() => {
        email_verified.innerHTML = "&nbsp;"; // Note: not empty space. Single space character to keep div uncollapsed, as 24px height is needed.
      }, 2000);
      localStorage.setItem("newsletter", "collected");
    } else {
      email_verified.innerHTML = "Please enter a valid phone number";
      footer_but.type = "button";
      footer_inp.style.borderColor = "#D74949";
      footer_but.style.borderColor = "#D74949";
    }
  }

  // document
  //   .getElementById("newsletter-form")
  //   .addEventListener("submit", function (e) {
  //     debugger;
  //     e.preventDefault();

  //     const email = document.getElementById("newsletter-email").value;
  //     const formData = new FormData();
  //     formData.append("form_type", "customer");
  //     formData.append("utf8", "✓");
  //     formData.append("contact[email]", email);

  //     fetch("/contact", {
  //       method: "POST",
  //       body: formData,
  //       headers: {
  //         Accept: "application/json",
  //       },
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.status === "success") {
  //           alert("Thank you for subscribing!");
  //         } else {
  //           alert("There was an issue with your subscription.");
  //         }
  //       })
  //       .catch((error) => console.error("Error:", error));
  //   });
});

Shopify.validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
